import React, { useState } from 'react';

const SBOMComparison = ({ imageData }) => {
  const [activeTab, setActiveTab] = useState('koala');

  if (!imageData) return null;

  const getPackageData = (type) => {
    if (type === 'koala') {
      return imageData.koala.sbom.packages || [];
    }
    return imageData.dockerhub.sbom.packages || [];
  };

  const currentPackages = getPackageData(activeTab);

  return (
    <div className="sbom-comparison">
      <div className="sbom-header">
        <h3>SBOM Comparison</h3>
        <div className="sbom-tabs">
          <button 
            className={`tab-button ${activeTab === 'koala' ? 'active' : ''}`}
            onClick={() => setActiveTab('koala')}
          >
            KoalaLab ({imageData.koala.sbom.totalPackages} packages)
          </button>
          <button 
            className={`tab-button ${activeTab === 'dockerhub' ? 'active' : ''}`}
            onClick={() => setActiveTab('dockerhub')}
          >
            DockerHub ({imageData.dockerhub.sbom.totalPackages} packages)
          </button>
        </div>
      </div>

      <div className="sbom-content">
        <div className="sbom-table-container">
          <table className="sbom-table">
            <thead>
              <tr>
                <th>Package</th>
                <th>Version</th>
                <th>Repository</th>
              </tr>
            </thead>
            <tbody>
              {currentPackages.map((pkg, index) => (
                <tr key={index} className={pkg.highlighted ? 'highlighted-package' : ''}>
                  <td className="package-name">
                    {pkg.name}
                    {pkg.type === 'main' && <span className="main-package-badge">Main package</span>}
                  </td>
                  <td className="package-version">{pkg.version}</td>
                  <td className="package-repository">
                    {pkg.repository}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SBOMComparison;